import { useEffect } from 'react';

import type { RefObject } from 'react';

// Верхние баннеры (обслуживание сервера, предупреждение биллинга) отрисованы
// как `position: fixed; top: 0` и иначе перекрывали бы верх сайдбара — аватар и
// селект филиала. Баннер публикует свою реальную высоту в CSS-переменную
// `--top-banner-height`, а лейаут страницы на эту высоту сдвигается вниз.
// Если видно несколько баннеров сразу, они накладываются друг на друга, поэтому
// берём максимальную высоту.
const TOP_BANNER_HEIGHT_VAR = '--top-banner-height';

const bannerHeights = new Map<string, number>();

const applyOffset = () => {
  const offset = bannerHeights.size ? Math.max(...bannerHeights.values()) : 0;

  document.documentElement.style.setProperty(
    TOP_BANNER_HEIGHT_VAR,
    `${offset}px`
  );
};

export const useTopBannerOffset = (
  bannerId: string,
  ref: RefObject<HTMLElement>,
  isVisible: boolean
) => {
  useEffect(() => {
    const element = ref.current;

    if (!isVisible || !element) {
      bannerHeights.delete(bannerId);
      applyOffset();

      return;
    }

    const updateHeight = () => {
      bannerHeights.set(bannerId, element.offsetHeight);
      applyOffset();
    };

    updateHeight();

    const observer = new ResizeObserver(updateHeight);
    observer.observe(element);

    return () => {
      observer.disconnect();
      bannerHeights.delete(bannerId);
      applyOffset();
    };
  }, [bannerId, ref, isVisible]);
};
